import { callApi } from './config/callApi'

export const invoices = async (method: string, data?: any | null): Promise<any> => {
  const url = method === 'get' ? '/invoices' : `/invoices/stars`

  return callApi({
    method,
    url,
    data,
  })
}
